export default [
  {
    label: "Node Index",
    name: "nodeIndex",
    type: "text",
    required: true,
  },
  {
    label: "Node Code",
    name: "nodecode",
    type: "text",
    required: true,
  },
  {
    label: "Node Name",
    name: "nodename",
    type: "text",
    required: true,
  },
  {
    label: "Due Days",
    name: "dueDays",
    type: "text",
    required: true,
  },
  {
    label: "Shared Rooms",
    name: "sharedRoomCount",
    type: "number",
    min: 1,
    step: 1,
    required: false,
    help: "Optional. Shared across this node's hospitals. CHG uses 9 shared rooms when blank; other nodes use each hospital's room count.",
  },
];
